import React from "react"

export function Delighted({ selected, handleGradeSelection }) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill={selected ? "#006D2C" : "none"}
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => handleGradeSelection(1)}
      className={selected ? "selected-survey" : "unselected-survey"}
    >
      <circle
        cx="40"
        cy="40"
        r="37.5"
        stroke={selected ? "#2c2c2c" : "#006D2C"}
        strokeWidth="5"
      />
      <circle cx="28" cy="24" r="5" fill={selected ? "#2c2c2c" : "#006D2C"} />
      <circle cx="53" cy="24" r="5" fill={selected ? "#2c2c2c" : "#006D2C"} />
      <path
        d="M23 45H58V46.5C58 56.165 50.165 64 40.5 64C30.835 64 23 56.165 23 46.5V45Z"
        fill={selected ? "#2c2c2c" : "#006D2C"}
      />
    </svg>
  )
}

export function Satisfied({ selected, handleGradeSelection }) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill={selected ? "#65E959" : "none"}
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => handleGradeSelection(2)}
      className={selected ? "selected-survey" : "unselected-survey"}
    >
      <circle
        cx="40"
        cy="40"
        r="37.5"
        stroke={selected ? "#2c2c2c" : "#65E959"}
        strokeWidth="5"
      />
      <circle cx="28" cy="24" r="5" fill={selected ? "#2c2c2c" : "#65E959"} />
      <circle cx="53" cy="24" r="5" fill={selected ? "#2c2c2c" : "#65E959"} />
      <path
        d="M23 52L28 55L33 57L38 57.5H43L48 57L53 55L58 52"
        stroke={selected ? "#2c2c2c" : "#65E959"}
        strokeWidth="5"
      />
    </svg>
  )
}

export function Neutral({ selected, handleGradeSelection }) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill={selected ? "#EBD935" : "none"}
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => handleGradeSelection(3)}
      className={selected ? "selected-survey" : "unselected-survey"}
    >
      <circle
        cx="40"
        cy="40"
        r="37.5"
        stroke={selected ? "#2c2c2c" : "#EBD935"}
        strokeWidth="5"
      />
      <circle cx="28" cy="24" r="5" fill={selected ? "#2c2c2c" : "#EBD935"} />
      <circle cx="53" cy="24" r="5" fill={selected ? "#2c2c2c" : "#EBD935"} />
      <line
        x1="25"
        y1="53.5"
        x2="56"
        y2="53.5"
        stroke={selected ? "#2c2c2c" : "#EBD935"}
        strokeWidth="5"
      />
    </svg>
  )
}

export function Dissatisfied({ selected, handleGradeSelection }) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill={selected ? "#E57535" : "none"}
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => handleGradeSelection(4)}
      className={selected ? "selected-survey" : "unselected-survey"}
    >
      <circle
        cx="40"
        cy="40"
        r="37.5"
        stroke={selected ? "#2c2c2c" : "#E57535"}
        strokeWidth="5"
      />
      <circle cx="28" cy="24" r="5" fill={selected ? "#2c2c2c" : "#E57535"} />
      <circle cx="53" cy="24" r="5" fill={selected ? "#2c2c2c" : "#E57535"} />
      <path
        d="M58 57.5L53 54.5L48 52.5L43 52H38L33 52.5L28 54.5L23 57.5"
        stroke={selected ? "#2c2c2c" : "#E57535"}
        strokeWidth="5"
      />
    </svg>
  )
}

export function Unhappy({ selected, handleGradeSelection }) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill={selected ? "#A50C0C" : "none"}
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => handleGradeSelection(5)}
      className={selected ? "selected-survey" : "unselected-survey"}
    >
      <circle
        cx="40"
        cy="40"
        r="37.5"
        stroke={selected ? "#2c2c2c" : "#A50C0C"}
        strokeWidth="5"
      />
      <circle cx="28" cy="24" r="5" fill={selected ? "#2c2c2c" : "#A50C0C"} />
      <circle cx="53" cy="24" r="5" fill={selected ? "#2c2c2c" : "#A50C0C"} />
      <path
        d="M58 59L23 59V57.5C23 47.835 30.835 40 40.5 40C50.165 40 58 47.835 58 57.5V59Z"
        fill={selected ? "#2c2c2c" : "#A50C0C"}
      />
    </svg>
  )
}
